import * as R from 'ramda';
import { httpGet } from 'apiModule/rest';
import adapter from 'dataModule/adapter';
import { getIdsObject, getQueriesString } from 'utilsModule';

const retrieveMany = async ({ params: { ids, queries } }) => {
  const url = R.pipe(
    getIdsObject,
    ({ patientId }) => `patients/${patientId}/contracts`,
  )(ids);

  return R.pipe(
    getQueriesString,
    queriesString => httpGet(`${url}${queriesString}`),
    response => response.then(adapter.contracts.retrieveMany.be2fe),
  )(queries);
};

const retrieveContractFormByUuid = async ({ params: { queries } }) => {
  return R.pipe(
    getQueriesString,
    queriesString => httpGet(`contracts${queriesString}`),
    response => response.then(adapter.contracts.retrieveContractFormByUuid.be2fe),
  )(queries);
};

const DM = {
  retrieveMany,
  retrieveContractFormByUuid
};

const ajax = async ({ method, input }) => ({
  [method]: await DM[method](input),
});

export default { ...DM, ajax, };
